/**
 * Komponent renderujący parametry (opcje nad tabelą)
 * Obsługuje wszystkie typy parametrów: search, select, datetime, date, list, checkbox, toggle, date_range
 */

import React, { FC } from 'react';
import { Switch as SwitchMui, FormControlLabel } from '@mui/material';
import { Checkbox } from 'components/controls';
import {WiseRangeButton, IRangeParameter } from 'components/wise';
import WiseTableSearch from 'components/wise/WiseTable/components/WiseTableSearch';
import WiseTableSelect from 'components/wise/WiseTable/components/WiseTableSelect';
import WiseTableFilterList from 'components/wise/WiseTable/components/WiseTableFilterList';

import { IWiseTableQueryParams, IWiseTableParameter } from 'components/wise/types';

interface ITableParametersProps {
  parameters: IWiseTableParameter[];
  queryParams: IWiseTableQueryParams;
  updateParameter: (fieldSymbol: string, value: any) => void;
}

/**
 * Komponent renderujący parametry tabeli
 */
const TableParameters: FC<ITableParametersProps> = ({
  parameters,
  queryParams,
  updateParameter
}) => {
  return (
    <>
      {parameters.map((parameter, i) => {
        const fieldSymbol = parameter.field_symbol || '';

        if (parameter.type === 'search') {
          return (
            <div key={i}>
              <WiseTableSearch
                placeholder={parameter.label}
                onChange={(value) => updateParameter(fieldSymbol, value)}
                value={queryParams[fieldSymbol] || ''}
              />
            </div>
          );
        }

        if (parameter.type === 'checkbox') {
          return (
            <div key={i}>
              <Checkbox
                checked={!!queryParams[fieldSymbol]}
                onClick={() => updateParameter(fieldSymbol, queryParams[fieldSymbol] ? 0 : 1)}
                label={parameter.label}
              />
            </div>
          );
        }

        if (parameter.type === 'toggle') {
          return (
            <div key={i}>
              <FormControlLabel
                control={
                  <SwitchMui
                    checked={Number(queryParams[fieldSymbol]) === 1}
                    onChange={(e) => updateParameter(fieldSymbol, e.target.checked ? 1 : 0)}
                  />
                }
                label={parameter.label}
                sx={{
                  '& .MuiFormControlLabel-label': {
                    fontSize: '14px'
                  }
                }}
              />
            </div>
          );
        }

        if (parameter.type === 'date_range' || parameter.type === 'range') {
          return (
            <div key={i}>
              <WiseRangeButton
                parameter={parameter as IRangeParameter}
                queryParams={queryParams}
                updateParameter={updateParameter}
                showRangeButton={parameter.type === 'date_range'}
              />
            </div>
          );
        }

        if (parameter.type === 'select') {
          return (
            <WiseTableSelect
              key={i}
              parameter={parameter}
              queryParams={queryParams}
              updateParameter={updateParameter}
            />
          );
        }

        if (parameter.type === 'list') {
          return (
            <WiseTableFilterList
              key={i}
              parameter={parameter}
              queryParams={queryParams}
              updateParameter={updateParameter}
            />
          );
        }

        return null;
      })}
    </>
  );
};

export default TableParameters;
